<template>
  <div class="container">
    <div class="row">
      <!-- Filtro -->
      <SearchFilter />
      <!-- Resultado da busca -->
      <SearchResults />
    </div>
  </div>
</template>

<script>
import SearchFilter from './layout/SearchFilter.vue'
import SearchResults from './layout/SearchResults.vue'
import { onMounted } from '@vue/runtime-core'
import { useSearch } from './composables/useSearch'
import { checkboxColorContainer } from './utils/checkboxColorContainer.js'
import { cleanFilter } from './utils/loadCleanFilter.js'
import { loadDropDowns } from './utils/loadDropDowns.js'

export default {
  components: { SearchFilter, SearchResults },
  setup() {
    const { loadProductTypes, loadTechnologicalArea, loadSearch } = useSearch()

    onMounted(async () => {
      try {
        await loadProductTypes()
        await loadTechnologicalArea()
      } catch (error) {
        console.log(error)
      } finally {
        cleanFilter()
        loadDropDowns()
        checkboxColorContainer()
        await loadSearch()
      }
    })
  },
}
</script>
